import useNotificationSocket from '@/components/Sidebar/useNotificationSocket'
import { UNREAD_NOTIFICATION_COUNT } from '@/constants/api'
import { getIsNotiAllowed } from '@/states/notification'
import { useCallback } from 'react'
import queryClient from '../queryClient'
import { JIKE_WEB_HOST } from '../request/host'

function useUnreadNotifier() {
	return useCallback((unreadCount: number) => {
		const isAllowed = getIsNotiAllowed()
		if (!isAllowed) {
			return
		}

		const notification = new Notification(`${unreadCount}条新互动`, {
			icon: 'https://m.okjike.com/favicon-32x32.png',
		})
		notification.onclick = () => {
			window.open(`${JIKE_WEB_HOST}/notification`, '_blank')
		}
	}, [])
}

export default function useNotificationService() {
	const notifyUnread = useUnreadNotifier()

	useNotificationSocket({
		onUserNotification: useCallback(
			(unreadCount: number) => {
				queryClient.setQueryData([UNREAD_NOTIFICATION_COUNT], unreadCount)
				unreadCount > 0 && notifyUnread(unreadCount)
			},
			[notifyUnread]
		),
	})
}
